import { makeStyles } from "tss-react/mui"
import { blueGrey } from "../../../../../mp-core/themes/palette"

export const useStyles = makeStyles()(({ spacing }) => ({
  globalSearchOption: {
    padding: spacing(2, 2, 2, 3),
    gap: spacing(2),
    display: "flex",
    alignItems: "flex-start !important",
    justifyContent: "space-between !important",
    cursor: "pointer",

    "&:not(:last-child)": {
      borderBottom: `1px solid ${blueGrey[100]}`
    },

    "&:hover": {
      backgroundColor: blueGrey[50]
    }
  },
  globalSearchOptionSubtitle: {
    color: blueGrey[500]
  }
}))
